export default "__VITE_ASSET__Ce3s1zit__"